import { useActiveCircle } from '../use-active-circle';
import { useMostRecentSponsorship } from '../use-most-recent-sponsorship';
import { useUnsponsoredConfig } from '../use-unsponsored-config';

/**
 * Hook to get consents based on the active circle.
 * It fetches the consents from either the most recent sponsorship or the unsponsored config.
 *
 * @returns { consents: CircleConsentConfig, isLoading: boolean }
 */
export function useConsents() {
    const {
        activeCircle,
        isFetched: isActiveCircleFetched,
        isEnabled,
    } = useActiveCircle();
    const { mostRecentSponsorship, isPending: isSponsorshipPending } =
        useMostRecentSponsorship();
    const { unsponsoredConfig, isPending: isUnsponsoredConfigPending } =
        useUnsponsoredConfig();

    const isSponsored = Boolean(activeCircle?.sponsor);

    if (!activeCircle) {
        return {
            consents: undefined,
            isLoading: isEnabled && !isActiveCircleFetched,
        };
    }

    const consents = activeCircle?.sponsor
        ? mostRecentSponsorship?.consents
        : unsponsoredConfig?.consents;

    return {
        consents,
        isLoading:
            !isActiveCircleFetched ||
            (isSponsored ? isSponsorshipPending : isUnsponsoredConfigPending),
    };
}
